module.exports = __webpack_public_path__ + "img/non_concrete_porch_veranda_roof_detached.0cda8e5c.jpg";